/**
 * Blocking notice for a session the user did NOT end themselves: the lease
 * lapsed, or the same user acquired a lock on another plan.
 *
 * Deliberately a modal rather than a toast. The user may be mid-edit when it
 * lands, and silently switching the page to read-only would leave them typing
 * into fields that no longer save.
 */
import type { FC } from 'react';
import { Button, Modal } from 'antd';

import { useTpoGenConfig } from '../../../context/CustomerConfigContext';
import { TPO_EDIT_SESSION_LOST_MODAL, TPO_EDIT_SESSION_LOST_OK_BTN } from '../../../config/testIds';
import { useEditSession } from '../EditSessionContext';

const SessionLostModal: FC = () => {
    const tpoGenConfig = useTpoGenConfig();
    const { sessionLost, acknowledgeSessionLost } = useEditSession();
    const labels = tpoGenConfig.labels.editSession;

    // A custom footer keeps the test id on our own Button rather than relying on
    // `okButtonProps` forwarding an unknown prop.
    const footer = (
        <Button type="primary" onClick={acknowledgeSessionLost} data-testid={TPO_EDIT_SESSION_LOST_OK_BTN}>
            {labels.sessionLostOk}
        </Button>
    );

    return (
        <Modal
            open={sessionLost}
            title={labels.sessionLostTitle}
            onCancel={acknowledgeSessionLost}
            footer={footer}
            closable={false}
            maskClosable={false}
            destroyOnClose
        >
            <p className="text-sm" data-testid={TPO_EDIT_SESSION_LOST_MODAL}>
                {labels.sessionLostBody}
            </p>
        </Modal>
    );
};

SessionLostModal.displayName = 'SessionLostModal';
export default SessionLostModal;
